import * as vp from 'vopay';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TransferFundsForm from './TransferFundsForm';
import usePostFundMyAccount from '../../../hooks/useApi/usePostFundMyAccount';
import usePostAccountTransferTo from '../../../hooks/useApi/usePostAccountTransferTo';
import { SubAccountTransferForm } from './types';
import { useClientData } from '../../../providers/ClientData.provider';
import { useConfirmDialog } from '../../../providers/ConfirmDialog.provider';
import styles from './TransferFunds.module.scss';
import useDataFetchIndicator from '../../../hooks/useDataFetchIndicator';

const { Title, Box } = vp;

const TransferFundsContainer: React.FC = () => {
  const { response } = useClientData();
  const confirmDialog = useConfirmDialog();
  const [, , , postAccountTransferTo] = usePostAccountTransferTo({});
  const [, , , postFundMyAccount] = usePostFundMyAccount({});
  const history = useHistory();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.TransferFunds.TransferFundsContainer' });

  const defaultValues: SubAccountTransferForm = {
    Amount: '',
    RecipientAccountID: response.ParentAccountID,
    DefaultOperationalBankAccount: '',
    TransferType: 'fundTransfer',
    ClientReferenceNumber: '',
    Notes: '',
    TransactionLabel: '',
    Currency: response.Country === 'US' ? 'USD' : 'CAD',
  };

  const onSubmit = async (values: SubAccountTransferForm) => {
    if (values.TransferType === 'fundTransfer') {
      try {
        setDataFetchingInfo(true, t('actions.processing') || '', 'fullScreen');
        const fundMyAccountResponse = await postFundMyAccount({
          ...values,
          Amount: Number(values.Amount),
          Token: values.DefaultOperationalBankAccount,
        });
        if (fundMyAccountResponse.Success) {
          const TransferTo = await postAccountTransferTo({
            ...values,
            Amount: Number(values.Amount),
            RecipientAccountID: values.RecipientAccountID,
            ParentTransactionID: fundMyAccountResponse.TransactionID,
          });
          if (TransferTo.Success) {
            history.push('/sub-accounts/transfer/fundTransfer/details', {
              FundingTransactionID: fundMyAccountResponse.TransactionID,
              AccountTransferID: TransferTo.TransactionID,
              AccountTransferIDs: {},
              ParentAccountName: response.ParentAccountName,
            });
          } else {
            confirmDialog.error(t('errorMessages.genericError'), {
              subTitle: TransferTo.ErrorMessage,
              cancelLabel: t('errorMessages.closeButton') || '',
            });
          }
        } else {
          confirmDialog.error(t('errorMessages.genericError'), {
            subTitle: fundMyAccountResponse.ErrorMessage,
            cancelLabel: t('errorMessages.closeButton') || '',
          });
        }
      } finally {
        setDataFetchingInfo(false);
      }
    }
  };

  return (
    <div className={styles.transferFundsContainer}>
      <Box flx="col" jc="center" maxwidth="1121px" boxWidth="100%" p="md">
        <Title textSize="32px" title={t('title')} />
        <Box base="8" pt="xmd">
          <TransferFundsForm onSubmit={onSubmit} defaultValues={defaultValues} />
        </Box>
      </Box>
    </div>
  );
};

export default TransferFundsContainer;
